import { render, staticRenderFns } from "./KnownMeasureTranslations.vue?vue&type=template&id=2b7791bf&"
import script from "./KnownMeasureTranslations.vue?vue&type=script&lang=js&"
export * from "./KnownMeasureTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports